"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeoutify = void 0;
const timeout_error_1 = require("./timeout-error");
function timeoutify(originalMethod, ms) {
    return function (...args) {
        return new Promise((resolve, reject) => {
            originalMethod.apply(this, args).then((data) => {
                resolve(data);
            }).catch(reject);
            setTimeout(() => {
                reject(new timeout_error_1.TimeoutError(ms));
            }, ms);
        });
    };
}
exports.timeoutify = timeoutify;
